import { render } from "./SchedulesMain.vue?vue&type=template&id=2aa63f15&scoped=true"
import script from "./SchedulesMain.vue?vue&type=script&lang=js"
export * from "./SchedulesMain.vue?vue&type=script&lang=js"

import "./SchedulesMain.vue?vue&type=style&index=0&id=2aa63f15&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa63f15"]])

export default __exports__